<template lang="pug">
    article.we
        NextPageTrigger(v-observe-visibility='e => {reachStartTrigger = e}', :triggerstart='reachStartTrigger', url='/clients')

        .we__main
            BlockVisibilityTrigger(:theme='"white"')
            .we__logo
                rambler-logo

            ul.we__counters.counters.counters--one-rows.counters--no-rounds
                li.we__counter.counter-item.counter-item--color-theme-light(v-for='({number, description} = count, counterIndex) in we.rg.counters')

                    .counter-item__number
                        span(v-html='number')

                    .counter-item__description
                        .counter-item__description-text(v-html='description')

            .we__text.we__text--small(v-html='we.rg.sup1')
            .we__text.we__text--small(v-html='we.rg.sup2')

            BlockVisibilityTrigger(:theme='"white"', :bottom='true')

        .we__text-box(v-observe-visibility='visibilityChanged')
            BlockVisibilityTrigger(:theme='"black"')
            .h1.h1--color-main.we__title(v-html='we.we.title')
            .we__text(v-html='we.we.text')

        //- .we__text-box(v-observe-visibility='visibilityChanged')
            .h1.h1--color-main.we__title(v-html='we.strategy.title')
            .we__text(v-html='we.strategy.text')

        //- .we__system
        //-     .h1.h1--color-main.we__title(v-html='we.system.title')
        //-     ul.cases
        //-         .case(v-for='item in we.system.list', v-observe-visibility='visibilityChanged')
        //-             h3.case-heading.case-heading--with-circle(v-html='item.title')
        //-             p.case-text(v-html='item.text')

        //-     BlockVisibilityTrigger(:theme='"black"', :bottom='true')

        NextPageHelper(:trigger='reachEndTrigger', urltext='Карьера', isBlack=true)
        Footer
        NextPageTrigger(v-observe-visibility='e => {reachEndTrigger = e}', :trigger='reachEndTrigger', url='/career')

</template>

<script>
import weData from '../assets/data/we.json';
import Footer from '../components/Footer.vue';
import NextPageTrigger from '../components/NextPageTrigger.vue';
import NextPageHelper from '../components/NextPageHelper.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';
import RamblerLogo from '@/components/RamblerLogo.vue';

export default {
    name: 'We',

    components: {
        Footer,
        NextPageTrigger,
        NextPageHelper,
        BlockVisibilityTrigger,
        RamblerLogo
    },

    data() {
        return {
            we: weData,
            reachEndTrigger: false,
            reachStartTrigger: false
        };
    },

    beforeMount() {},

    mounted() {},

    methods: {
        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';
@import '../assets/css/animations.scss';

:root {
    --vh: 5.68px;
}

.we {
    background-color: var(--color-main-bg);

    &__main {
        position: relative;
        padding-top: 38vh;
        align-items: center;
        background-image: url('../assets/img/we/bg.jpg');
        background-size: cover;
        background-position: center;
        color: var(--color-accent-text);
        margin-bottom: 4em;

        @supports (--css: variables) {
            min-height: calc(var(--vh) * 100);
        }

        @media (--viewport-tablet) {
            padding-top: 5em;
        }
    }

    &__wrap {
        margin: 0 auto;
        padding-top: 2.8em;
    }

    &__text-box,
    &__logo,
    &__system {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    &__text-box {
        opacity: 0;
        transform: translateY(50px);
        text-align: justify;

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }
    }

    &__logo {
        padding-bottom: 6em;
        text-align: center;

        svg {
            fill: var(--color-accent-text);
        }
    }

    &__title {
        text-align: center;
        margin-bottom: 1.3em;

        @media (--viewport-tablet) {
            text-align: left;
        }
    }

    &__text {
        margin-bottom: 3em;
        max-width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin-left: auto;
        margin-right: auto;

        @media (--viewport-tablet) {
            max-width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }

        &::v-deep p {
            margin-bottom: 1em;
        }

        &--min-margin {
            margin-bottom: 1em;
        }

        &--small {
            font-size: 0.6em;
            text-align: center;
        }
    }

    &__counters {
        width: calc(var(--layout-column-width) * 9 + var(--layout-gutter-width) * 8);
        grid-template-columns: 3fr 3fr 3fr;
        padding-left: 0;
        margin: 0 auto;

        @media (--viewport-laptop-l) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }

        @media (--viewport-tablet) {
            grid-template-columns: 1fr;
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    .counter-item__number {
        font-size: calc(var(--layout-gutter-width) * 1.5);

        @media (--viewport-tablet) {
            font-size: calc(var(--layout-gutter-width) * 3.85);
        }

        &::v-deep em {
            font-size: calc(var(--layout-gutter-width) * 0.7);
            vertical-align: middle;

            @media (--viewport-tablet) {
                font-size: calc(var(--layout-gutter-width) * 2);
            }
        }
    }

    &__item {
        margin-bottom: 1em;
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }

        &--with-photo {
            padding-left: calc(var(--layout-gutter-width) + var(--layout-column-width));

            @media (--viewport-tablet) {
                padding-left: 0;
            }
        }
    }

    .case {
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }
    }

    &__system {
        position: relative;
        padding-bottom: 5em;

        @media (--viewport-tablet) {
            padding-bottom: 3em;
        }
    }
}
</style>
